import { observer } from 'mobx-react-lite';
import styled from '@emotion/styled';
import { IContentSearchResult } from '../../domain/types/IContentSearchResult';
import { SearchResultItem } from './SearchResultItem';

interface IProps {
	results: IContentSearchResult[];
}

export const List = observer(({ results }: IProps) => (
	<StyledList>
		{results.map((result) => (
			<li key={result.id} className="no-max-width">
				<SearchResultItem result={result} />
			</li>
		))}
	</StyledList>
));

const StyledList = styled.ul`
	list-style: none;
	padding: 0;
	margin: 0;

	li {
		padding: 0;
	}
`;
